import { Box, Flex, chakra } from "@chakra-ui/react"

import { useIsCompactScreen } from "@/hooks/useIsCompactScreen"

import { Step } from "./Step"
import { stepperContext } from "./StepperContext"
import { useProgressState } from "./useProgressState"

type Props = React.PropsWithChildren<{ steps: { label: string }[]; stepWidth?: number }>

export default function Stepper({ steps, children, stepWidth }: Props) {
  const { getState, onClick, goToNextStep, activeStep } = useProgressState()
  const compact = useIsCompactScreen()

  return (
    <stepperContext.Provider
      value={{ goToNextStep, isLastStep: activeStep === steps.length - 1, activeStep }}
    >
      <Box mx="auto" py="4" px="4" bg="surface">
        <Box as="nav" aria-label="Steps" position="relative">
          <chakra.hr
            border="none"
            borderTop="2px solid"
            borderColor="lineStrong"
            height="1px"
            position="absolute"
            top="50%"
            bottom="50%"
            w="100%"
            aria-hidden
          />
          <Flex justify="space-between" align="center" as="ol" listStyleType="none" zIndex={1}>
            {steps.map((step, index) => (
              <Step
                label={step.label}
                // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
                key={index}
                state={getState(index)}
                onClick={onClick(index)}
                number={index + 1}
                stepWidth={stepWidth}
                compact={compact}
              />
            ))}
          </Flex>
        </Box>
      </Box>
      {children}
    </stepperContext.Provider>
  )
}
